const BRAND_CURATION_TASK_STATUS = {
  NOT_STARTED: {
    value: 'NOT_STARTED',
    label: 'Not started',
  },
  STARTED: {
    value: 'STARTED',
    label: 'Started',
  },
  REOPENED: {
    value: 'REOPENED',
    label: 'Reopened',
  },
  RESOLVED: {
    value: 'RESOLVED',
    label: 'Resolved',
  },
  AUTOMATICALLY_RESOLVED: {
    value: 'AUTOMATICALLY_RESOLVED',
    label: 'Automatically Resolved',
  },
}

module.exports = BRAND_CURATION_TASK_STATUS
